module.exports = __webpack_public_path__ + "img/facebook-ads.7b5f75c8.svg";